var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmyOverseasService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 250,
    viewBox: "0 0 650 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_49)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 250,
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    width: 80,
    height: 250,
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 140,
    height: 250,
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    width: 140,
    height: 250,
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    width: 35,
    height: 250,
    fill: "#EEBE00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395,
    width: 35,
    height: 250,
    fill: "#EEBE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 0H395V250H255V0Z",
    fill: "#790817"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmyOverseasService);
export default __webpack_public_path__ + "static/media/Army Overseas Service.597a7315270758ec726934169c961cbe.svg";
export { ForwardRef as ReactComponent };